export const renderImage = (image) => {
  if (!image)
    return "https://flyinn-app-bucket.s3.us-east-1.amazonaws.com/uploads/sample_listing.webp";

  if (image?.includes("https://s3")) {
    return image;
  } else {
    return `https://s3.amazonaws.com/flyinn-app-bucket/listing/${image}`;
  }
};
